import React from "react";
import { Colours } from "Examples/Colours";

export const HomeView: React.FC = () => {
    return <Colours />;
};
